module.exports = __webpack_public_path__ + "img/facepaint-1_en.f826c75.jpg";